export default __webpack_public_path__ + "static/media/848.f31d1588.gif";